import svgCrosswordGenerator from './svgCrosswordGenerator';
import generateHuntingWordsSVG from './svgGenerator';
import generateGameSVG from './generateGameSvg';
import generateFencesSVG from './generateFencesSvg';

export const GAME_TYPES = {
  CROSSWORD: 'crossword',
  WORD_SEARCH: 'wordsearch',
  SHAPE_LINKS: 'shapelinks',
  LOOP: 'loop',
  NUMBER_SQUARE: 'numberSquare',
  FENCES: 'fences',
  WALLS: 'walls',
};

const TOGGLE_OPTIONS = {
  colored: { key: 'colored', label: 'Colorido' },
  transparentBg: { key: 'transparentBackground', label: 'Fundo Transparente' },
  exportBank: { key: 'exportBank', label: 'Incluir Banco de Palavras' },
};

const RADIO_GROUPS = {
  arrowStyle: {
    key: 'arrowHeadStyle',
    label: 'Tipo de Seta:',
    choices: [
      { value: 'default', label: 'Triângulo' },
      { value: 'filled', label: 'Círculo Preenchido' },
      { value: 'empty', label: 'Círculo Vazado' },
      { value: 'dotted', label: 'Círculo com Ponto' },
    ],
  },
  pathWeight: {
    key: 'exportPathWeight',
    label: 'Espessura da linha:',
    choices: [
      { value: 'thin', label: 'Fina' },
      { value: 'normal', label: 'Normal' },
      { value: 'bold', label: 'Espessa' },
    ],
  },
};

export const EXPORT_CONFIG = {
  [GAME_TYPES.CROSSWORD]: {
    types: {
      enigma: { label: 'Enigma', suffix: '', defaultSelected: true },
      solution: { label: 'Solução', suffix: 'r', defaultSelected: true },
      combined: { label: 'Enigma + Solução', suffix: '_completo', defaultSelected: false },
    },
    toggles: [TOGGLE_OPTIONS.transparentBg, TOGGLE_OPTIONS.exportBank],
    radioGroups: [RADIO_GROUPS.arrowStyle],
    useIndexNaming: false,
    generateSvg: (item, typeKey, options) => {
      const modeMap = { enigma: 'enigma', solution: 'solution', combined: 'combined' };
      const config = {
        ...item.settings, ...options, exportMode: modeMap[typeKey], bank: item.bank || [], bankPosition: 'right',
      };
      return svgCrosswordGenerator(item.table, item.rows, item.columns, config);
    },
  },

  [GAME_TYPES.WORD_SEARCH]: {
    types: {
      enigma: { label: 'Enigma', suffix: '_Enigma', defaultSelected: true },
      solution: { label: 'Solução', suffix: '_Solucao', defaultSelected: true },
      listWord: {
        label: 'Lista de palavras', suffix: '_Palavras', isText: true, defaultSelected: true,
      },
    },
    toggles: [],
    radioGroups: [],
    useIndexNaming: true,
    generateSvg: (item, typeKey) => {
      if (typeKey === 'enigma') {
        return generateHuntingWordsSVG(item.table, item.rows, item.columns);
      }
      return generateHuntingWordsSVG(item.table, item.rows, item.columns, {
        highlightedWords: item.highlightedWords,
      });
    },
  },

  [GAME_TYPES.SHAPE_LINKS]: {
    types: {
      enigma: { label: 'Enigma', suffix: '_Enigma', defaultSelected: true },
      solution: { label: 'Solução', suffix: '_Solucao', defaultSelected: true },
    },
    toggles: [TOGGLE_OPTIONS.colored, TOGGLE_OPTIONS.transparentBg],
    radioGroups: [RADIO_GROUPS.pathWeight],
    useIndexNaming: false,
    generateSvg: (item, typeKey, options) => {
      const config = {
        ...item.settings,
        colored: options.colored,
        pathWeight: options.exportPathWeight,
        transparentBackground: options.transparentBackground,
        showAnswer: typeKey === 'solution',
      };
      return generateGameSVG(item.table, item.rows, item.columns, config);
    },
  },

  [GAME_TYPES.LOOP]: {
    types: {
      enigma: { label: 'Enigma', suffix: '_Enigma', defaultSelected: true },
      solution: { label: 'Solução', suffix: '_Solucao', defaultSelected: true },
    },
    toggles: [TOGGLE_OPTIONS.colored, TOGGLE_OPTIONS.transparentBg],
    radioGroups: [RADIO_GROUPS.pathWeight],
    generateSvg: (item, typeKey, options) => {
      const config = {
        ...item.settings,
        colored: options.colored,
        pathWeight: options.exportPathWeight,
        transparentBackground: options.transparentBackground,
        showAnswer: typeKey === 'solution',
      };

      return generateGameSVG(item.table, item.rows, item.columns, config);
    },
  },

  [GAME_TYPES.NUMBER_SQUARE]: {
    types: {
      enigma: { label: 'Enigma', suffix: '_Enigma', defaultSelected: true },
      solution: { label: 'Solução', suffix: '_Solucao', defaultSelected: true },
    },
    toggles: [TOGGLE_OPTIONS.transparentBg],
    radioGroups: [],
    generateSvg: (item, typeKey, options) => {
      const config = {
        ...item.settings,
        colored: options.colored,
        pathWeight: options.exportPathWeight,
        transparentBackground: options.transparentBackground,
        showAnswer: typeKey === 'solution',
      };

      return generateGameSVG(item.table, item.rows, item.columns, config);
    },
  },

  [GAME_TYPES.FENCES]: {
    types: {
      enigma: { label: 'Enigma', suffix: '_Enigma', defaultSelected: true },
      solution: { label: 'Solução', suffix: '_Solucao', defaultSelected: true },
    },
    toggles: [TOGGLE_OPTIONS.colored, TOGGLE_OPTIONS.transparentBg],
    radioGroups: [],
    generateSvg: (item, typeKey, options) => {
      const config = {
        ...item.settings,
        colored: options.colored,
        pathWeight: options.exportPathWeight,
        transparentBackground: options.transparentBackground,
        showAnswer: typeKey === 'solution',
      };

      return generateFencesSVG(item.table, item.rows, item.columns, config);
    },
  },

  [GAME_TYPES.WALLS]: {
    types: {
      enigma: { label: 'Enigma', suffix: '_Enigma', defaultSelected: true },
      solution: { label: 'Solução', suffix: '_Solucao', defaultSelected: true },
    },
    toggles: [TOGGLE_OPTIONS.transparentBg],
    radioGroups: [],
    generateSvg: (item, typeKey, options) => {
      const config = {
        ...item.settings,
        colored: options.colored,
        pathWeight: options.exportPathWeight,
        transparentBackground: options.transparentBackground,
        showAnswer: typeKey === 'solution',
      };

      return generateGameSVG(item.table, item.rows, item.columns, config);
    },
  },
};
